<template>
  <div>
    <header id="masthead" class="registration">
      <div class="wp1200">
        <a class="logo" href></a>
        <div v-if="showToastError">
          <div
            style="
              margin-bottom: 25px;
              padding: 20px;
              background-color: #ef5451;
              border-radius: 20px;
              color: white;
              display: -webkit-flex;
              display: flex;
              align-items: center;
            "
          >
            <span class="warpit_icon_alert" style="font-size: 32px; margin-right: 15px"></span>
            {{ showToastMessage }}
          </div>
        </div>
      </div>
    </header>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration settings padd">
          <hr class="blue" />
          <ul>
            <li class="title flex">
              <label class="labelTxt">{{ $t("profile.notification_settings") }}</label>
              <div class="titleIcons flex">
                <span class="icon"></span>
                <span class="icon warpit_icon_mail"></span>
              </div>
            </li>
            <li class="flex">
              <label class="labelTxt">{{ $t("profile.email_setting") }}</label>
              <div class="switchLabels flex">
                <label class="switch"></label>
                <label class="switch">
                  <input type="checkbox" v-bind:checked="isChecked" v-on:click="switchClicked()" />
                  <span class="slider round"></span>
                </label>
              </div>
            </li>
          </ul>

          <div class="next flex">
            <a class="txt" href v-on:click.prevent="formUtilsCancel()">{{ $t("profile.cancel") }}</a>

            <a
              class="join smallFont smallWidth hoverEffect"
              ref="joinButton1"
              v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton1')"
              v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton1')"
              v-on:click.prevent="onSubmit()"
              href="javascript:void(0);"
            >
              <label>{{ $t("profile.save") }}</label>
              <span
                class="effect"
                ref="effectButton1"
                v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
              ></span>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { formUtilsMouseHoverEffect} from '@/utils/form_utils.js';

export default {
  data() {
    return {
      showToastError: false,
      showToastMessage: "",
      topX: 1,
      leftX: 1,

      isChecked: false,
      userStatus: "1",
      recaptchaToken: "",
      recaptchaSiteKey: window.VUE_APP_RECAPTCHA_KEY,
    };
  },
  components: {
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    status() {
      return this.$store.getters["user/status"];
    },
  },
  mounted() {
    this.isChecked = this.status.status == "1" ? true : false;
    this.userStatus = this.status.status;
  },
  methods: {
    formUtilsMouseHoverEffect,

    async onSubmit() {
      /* CHECK FIELDS BEFORE SUBMIT */

      /* CHECK CAPTCHA */
      this.$checkRecaptcha().then((token) => {
        this.sendForm(token);
      }).catch((error) => {
        console.error("Error reCAPTCHA:", error);
      });
    },


    sendForm(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
      this.$http
        .put("api/v1/userStatus?status=" + this.userStatus)
        .then(() => {
          this.$store.dispatch("user/userinfo");
          this.$router.back();
          return;
        })
        .catch(() => {
          this.showToastError = true;
          this.showToastMessage = this.$t("error.invalid_update");
        });
    },
    switchClicked() {
      this.userStatus = this.userStatus == "9" ? "1" : "9";
    }    
  },
};
</script>

<style >
</style>